import { ITutor } from '@wot/typings';
import { Table, TableBody, TableHeading, TableHeadingCol, TableRow } from '../../../../components/Table';
import { TableRowItem } from './TableRowItem';
import { useNavigate } from 'react-router-dom';
import { BiSort } from 'react-icons/bi';
import { ISorting } from '..';

interface Props {
  data: ITutor[];
  handleSort?: (key: ISorting) => void;
}

export default function TableContainer({ data, handleSort }: Props) {
  const navigate = useNavigate();
  return (
    <Table>
      <TableHeading>
        <TableRow>
          <TableHeadingCol
            onClick={() => handleSort && handleSort('createdAt')}
            label="Date"
            component={
              <div className="flex items-center">
                <p className="">Date</p>
                <BiSort className="text-sm" />
              </div>
            }
          />
          <TableHeadingCol label="Tutor ID" />
          <TableHeadingCol label="NAME" />
          <TableHeadingCol label="EMAIL" />
          <TableHeadingCol label="PHONE NO." />
          <TableHeadingCol label="Level" />
          <TableHeadingCol label="STATUS" />
        </TableRow>
      </TableHeading>
      <TableBody>
        {data.map((tutor) => (
          <TableRow key={tutor._id}>
            <TableRowItem tutor={tutor} />
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
